import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class ProtectionMandateGenerateOption extends Enum {
  key!: string;
  value!: string;

  static YES: ProtectionMandateGenerateOption = {
    key: 'yes',
    get value(): string {
      return Lang.t('powerofattorney.yes-i-do');
    }
  };

  static NO_ALREADY_HAVE: ProtectionMandateGenerateOption = {
    key: 'no_already_have',
    get value(): string {
      return Lang.t('powerofattorney.no-i-have-one');
    }
  };

  static NO: ProtectionMandateGenerateOption = {
    key: 'no',
    get value(): string {
      return Lang.t('powerofattorney.no-i-dont');
    }
  };
}
